import { get, put, del, type PublicUser } from "./api";
export interface SocialStatus {
  followers: number;
  following: number;
  followedByViewer: boolean;
}
export interface PeoplePage {
  items: (PublicUser & { publicRepositories?: number })[];
  total: number;
  page: number;
  perPage: number;
}
export const socialStatus = (username: string) =>
  get<SocialStatus>(`/users/${encodeURIComponent(username)}/social`);
export const followPerson = (username: string, following: boolean) =>
  following
    ? put<SocialStatus>(`/users/${encodeURIComponent(username)}/follow`, {})
    : del<SocialStatus>(`/users/${encodeURIComponent(username)}/follow`);
